import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Avviso di manutenzione in cima al gestionale. Per toglierlo basta impostare il testo a null.
const MAINTENANCE_NOTICE: string | null = null;

const MaintenanceBanner: React.FC = () => {
    if (!MAINTENANCE_NOTICE) return null;
    return (
        <div
            role="status"
            className="maint-banner flex items-center gap-2 bg-amber-100 text-amber-900 border-b border-amber-300 text-sm font-semibold overflow-hidden whitespace-nowrap"
            style={{ minHeight: 32 }}
        >
            <style>{`
                .maint-banner .maint-track { display: inline-block; padding-left: 100%; animation: maint-scroll 60s linear infinite; }
                .maint-banner:hover .maint-track { animation-play-state: paused; }
                @keyframes maint-scroll { from { transform: translateX(0); } to { transform: translateX(-100%); } }
                @media (prefers-reduced-motion: reduce) {
                    .maint-banner { white-space: normal; }
                    .maint-banner .maint-track { animation: none; padding-left: 0; }
                }
            `}</style>
            <span className="flex-shrink-0 pl-3 py-1.5 bg-amber-100 relative z-10">
                <AlertTriangle size={16} className="text-amber-700" />
            </span>
            <div className="flex-1 overflow-hidden py-1.5">
                <span className="maint-track">{MAINTENANCE_NOTICE}</span>
            </div>
        </div>
    );
};

export default MaintenanceBanner;
